import React, { useState, useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import Context from "../Context";
export default () => {
  const context = useContext(Context);

  const [show, set_show] = useState(false);
  // const [title, set_title] = useState("");
  const [description, set_description] = useState("");
  const [actions, set_actions] = useState([]);

  context.showConfirmationModal = (
    input_title,
    input_description,
    input_actions
  ) => {
    // set_title(input_title);
    set_description(input_description);
    set_actions(input_actions);
    set_show(true);
  };

  return (
    <Modal
      show={show}
      style={{ zIndex: 9999 }}
      size="lg"
      onHide={() => {
        set_show(false);
      }}
    >
      <Modal.Body>
        <Modal.Body>{description}</Modal.Body>
        <Modal.Footer>
          {actions.map((action, index) => (
            <Button
              key={index}
              variant={action.variant || "secondary"}
              onClick={(e) => {
                action.onClick(e);
                set_show(false);
              }}
            >
              {action.label}
            </Button>
          ))}
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};
